import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "./supabaseClient";

const UserDashboard = ({ user, auctionCodes }) => {
  const [userAuctions, setUserAuctions] = useState(auctionCodes || []);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const fetchUserAuctions = useCallback(async () => {
    try {
      if (!user || !user.id) {
        console.error("User ID not found in user object. User:", user);
        setErrorMessage("User not authenticated. Please log in again.");
        return;
      }

      const { data, error } = await supabase
        .from("auctions")
        .select("auction_name, auction_code")
        .eq("user_id", user.id);

      if (error) {
        throw error;
      }

      setUserAuctions(data || []);
    } catch (error) {
      console.error("Error fetching auctions:", error.message);
      setErrorMessage("Failed to load auctions. Please try again later.");
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      fetchUserAuctions();
    }
  }, [user, fetchUserAuctions]);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  if (!user) {
    return <p>Please log in to access your dashboard.</p>;
  }

  return (
    <div>
      <h1>Welcome, {user.email}!</h1>

      {/* Button to create a new auction */}
      <button onClick={() => navigate("/auction-setup")} style={buttonStyle}>
        Create Auction
      </button>

      {/* Button to participate in an auction */}
      <button onClick={() => navigate("/join-auction")} style={buttonStyle}>
        Participate in Auction
      </button>

      <h2>Your Auctions</h2>
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

      {/* List of Auctions */}
      {userAuctions.length > 0 ? (
        <ul>
          {userAuctions.map((auction) => (
            <li key={auction.auction_code}>
              <span>{auction.auction_name}</span>
              <button
                onClick={() => navigate(`/auction-admin/${auction.auction_code}`)}
                style={manageButtonStyle}
              >
                Manage Auction
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>No auctions found. Create or participate in an auction to see them here!</p>
      )}
    </div>
  );
};

// Styles for the buttons
const buttonStyle = {
  margin: "10px",
  padding: "10px 20px",
  fontSize: "16px",
  cursor: "pointer",
};

const manageButtonStyle = {
  marginLeft: "10px",
  padding: "5px 10px",
  fontSize: "14px",
  cursor: "pointer",
};

export default UserDashboard;
